import {
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_ERROR,
  VERIFY_MFA_CODE,
  VERIFY_MFA_CODE_SUCCESS,
  VERIFY_MFA_CODE_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes";


// Step 1: Request Password Reset - sends the MFA code to the user's email
export const requestPasswordReset = (email) => {
  return {
    type: REQUEST_PASSWORD_RESET,
    payload: { email },
  };
};

export const requestPasswordResetSuccess = (message) => {
  return {
    type: REQUEST_PASSWORD_RESET_SUCCESS,
    payload: message,
  };
};

export const requestPasswordResetError = (message) => {
  return {
    type: REQUEST_PASSWORD_RESET_ERROR,
    payload: message,
  };
};

// Step 2: Verify MFA Code
export const verifyMFA = (email, code) => {
  return {
    type: VERIFY_MFA_CODE,
    payload: { email, code },
  };
};

export const verifyMFASuccess = (message) => {
  return {
    type: VERIFY_MFA_CODE_SUCCESS,
    payload: message,
  };
};

export const verifyMFAError = (message) => {
  return {
    type: VERIFY_MFA_CODE_ERROR,
    payload: message,
  };
};

// Step 3: Reset Password
export const resetPassword = (email, code, password) => {
  return {
    type: RESET_PASSWORD,
    payload: { email, code, password },
  };
};

export const resetPasswordSuccess = (message) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const resetPasswordError = (message) => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: message,
  };
};
